import React, { useState, useEffect } from 'react'

import { Button, Dialog, Grid, Icon, Typography, Select, Switch, FormHelperText } from '@material-ui/core'

import Scrollbars from "rc-scrollbars";
import CloseIcon from '@material-ui/icons/Close';
import useStyles from "./styles";
import { Label, DraggableComponent } from '../../../../../components/UiElements/UiElements';
import { SelectField, InputBaseField, TextareaField } from '../../../../../components/InputField/InputField';
import DialogLoader from './../../../../../components/Loader/DialogLoader';
import { GetUserInfo } from '../../../../../Services/GetUserInfo';
import { PostDataAPI } from '../../../../../Services/APIService';
import { withSnackbar } from "./../../../../../components/Message/Alert";
import { validateEmail, handleNumberKeyPress, isDigitsOnly, formateMdnNumber, validatePhoneNumber } from '../../../../../../src/components/Common/Extensions';

function AddNewAgency({ dialogOpenClose, handleClose, handleSuccessClose, selectedAgencyId, ...props }) {
    const classes = useStyles();
    const { showMessage } = props;
    const [isLoading, setIsLoading] = useState(false);

    const [state, setState] = useState(false);
    const [defaultTemplate, setDefaultTemplate] = useState("Select Region");
    const regions = [
        { label: 'Select Region', value: '' },
        {
            label: "North America",
            value: "North America",
        },
        {
            label: "Caribbean",
            value: "Caribbean",
        },
        {
            label: "India",
            value: "India",
        },
        {
            label: "Africa",
            value: "Africa",
        },
        {
            label: "Global Coverage",
            value: "Global Coverage",
        },
        {
            label: "Other",
            value: "Other",
        },
    ]
    const [errorMessages, setErrorMessages] = useState({});

    const handleChange = e => {
        const { name, value } = e.target;
        setState(prevState => ({
            ...prevState,
            [name]: value
        }));
    }
    const handlePhoneChange = e => {
        const { name, value } = e.target;
        if (e.nativeEvent.data != "e") {

            if (e.nativeEvent.data != null || e.target.value != "") {
                // for fomatting
                const re = /^[0-9\b]+$/;
                e.target.value = e.target.value.replace(' ', '').replace('(', '').replace(')', '').replace('-', '');
                const { name, value } = e.target;
                if ((e.target.value === '' || re.test(e.target.value))) {

                    var cleaned = ('' + e.target.value).replace(/\D/g, '')
                    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/)
                    if (match) {
                        var intlCode = (match[1] ? '+1 ' : ''),
                            number = [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');

                        setState(prevState => ({
                            ...prevState,
                            [name]: number
                        }));
                        return;
                    }
                    setState(prevState => ({
                        ...prevState,
                        [name]: value
                    }));
                }
                else {
                    if (!re.test(e.target.value)) {
                        e.preventDefault();
                    }

                }
            }
            else {
                setState(prevState => ({
                    ...prevState,
                    [name]: value
                }));

                if (e.target.value != "") {

                    setErrorMessages(prevState => ({
                        ...prevState,
                        errorPhoneLength: true
                    }));
                }

            }
        }
        else
            e.preventDefault();
    }
    const Validate = (errorList) => {
        if (!state.agencyName) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorAgencyName: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorAgencyName: false
            }));
        }
        if (!state.email) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEmailAddress: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorEmailAddress: false
            }));
        }
        if (state.email && !validateEmail(state.email)) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorValidEmail: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorValidEmail: false
            }));
        }

        if (!state.phone) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPhoneNumber: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorPhoneNumber: false
            }));
        }
        if (state.phone && !validatePhoneNumber(state.phone)) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorInvalidPhone: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorInvalidPhone: false
            }));
        }
        if (!state.region) {
            setErrorMessages(prevState => ({
                ...prevState,
                errorRegion: true
            }));
            errorList.push(true);
        }
        else {
            setErrorMessages(prevState => ({
                ...prevState,
                errorRegion: false
            }));
        }
        
        //if (!state.contactPerson) {
        //    setErrorMessages(prevState => ({
        //        ...prevState,
        //        errorContactPerson: true
        //    }));
        //    errorList.push(true);
        //}
        //else {
        //    setErrorMessages(prevState => ({
        //        ...prevState,
        //        errorContactPerson: false
        //    }));
        //}

    }
    const addAgency = () => {
        let errorList = [];
        Validate(errorList);
        if (errorList.length < 1) {
            setIsLoading(true);
            var method = "fdnagency/addAgency";
            if (selectedAgencyId > 0)
                method = "fdnagency/update";

            state.agencyName = state.agencyName.trim();
            state.email = state.email.trim();
            state.phone = state.phone.trim();
            state.agencyCategory = "PR";
            state.contactPerson = state.contactPerson ? state.contactPerson.trim() : '';
            PostDataAPI(method, state, true).then((result) => {
                setIsLoading(false)
                if (result.success && result.data) {
                    var message = "Agency added successfully";
                    if (selectedAgencyId > 0)
                        message = "Agency updated successfully";
                    handleSuccessClose(message);
                } else {
                    showMessage("Error", result.message, "error", 3000);
                }
            })
        }

    }
    const loadAgency = () => {
        setIsLoading(true);
        PostDataAPI("fdnagency/get", selectedAgencyId).then((result) => {
            if (result.success && result.data) {
                setState(result.data);
            }
            else {
                showMessage("Error", result.message, "error", 3000);
            }
            setIsLoading(false);
        });
    }
    useEffect(() => {
        if (selectedAgencyId && selectedAgencyId > 0)
            loadAgency();
    }, []);


    return (
        <>

            <Dialog
                classes={{ paper: classes.dialogPaper }}
                disableEscapeKeyDown
                open={dialogOpenClose}
                maxWidth="md"
                PaperComponent={DraggableComponent}
                {...props} >
                <div className={classes.activeDialogContent}>
                    <div className={classes.box}>
                        <div className={classes.header} id="draggable-dialog-title">
                            <Typography className={classes.title}>{selectedAgencyId && selectedAgencyId > 0 ? "Edit Agency" : "Add New Agency"}</Typography>
                            <Icon className={classes.closeIcon} onClick={handleClose} color="primary"><CloseIcon /></Icon>
                        </div>
                        {isLoading ? <DialogLoader></DialogLoader> : ''}

                        <div className={classes.content}>
                            <Grid container spacing={2}>

                                <Grid lg={6} md={6} xs={12} sm={12} className={classes.paddingLeftRight} >
                                    <Grid row >
                                        <Label item title="Agency Name" size={12} mandatory={true} />
                                        <Grid lg={12} md={12} sm={12}>
                                            <InputBaseField
                                                name="agencyName"
                                                type="text"
                                                placeholder="Agency Name"
                                                MaxLength="50"
                                                value={state.agencyName}
                                                onChange={handleChange}
                                            />
                                            {errorMessages.errorAgencyName && !state.agencyName ? (<FormHelperText style={{ color: "red" }} >
                                                Please enter agency name
                                            </FormHelperText>) : ('')}
                                        </Grid>
                                    </Grid>

                                </Grid>

                                <Grid lg={6} md={6} xs={12} sm={12} className={classes.paddingLeftRight} >
                                    <Grid row >
                                        <Label item title="Email Address" size={12} mandatory={true} />
                                        <Grid lg={12} md={12} sm={12}>
                                            <InputBaseField
                                                name="email"
                                                type="text"
                                                placeholder="Email Address"
                                                MaxLength="50"
                                                value={state.email}
                                                onChange={handleChange}
                                            />
                                            {errorMessages.errorEmailAddress && !state.email ? (<FormHelperText style={{ color: "red" }} >
                                                Please enter email address
                                            </FormHelperText>) : ('')}
                                            {errorMessages.errorValidEmail && (state.email && !validateEmail(state.email)) ? (<FormHelperText style={{ color: "red" }} >
                                                Please enter valid email
                                            </FormHelperText>) : ('')}
                                        </Grid>
                                    </Grid>

                                </Grid>

                                <Grid lg={6} md={6} xs={12} sm={12} className={classes.paddingLeftRight} >
                                    <Grid row >
                                        <Label item title="Phone Number" size={12} mandatory={true} />
                                        <Grid lg={12} md={12} sm={12}>
                                            <InputBaseField
                                                name="phone"
                                                type="text"
                                                placeholder="Phone Number"
                                                MaxLength={14}
                                                value={formateMdnNumber(state.phone)}
                                                onChange={handlePhoneChange}
                                            />
                                            {errorMessages.errorPhoneNumber && !state.phone ? (<FormHelperText style={{ color: "red" }} >
                                                Please enter phone number
                                            </FormHelperText>) : ('')}
                                            {errorMessages.errorInvalidPhone && state.phone && !validatePhoneNumber(state.phone) ? (<FormHelperText style={{ color: "red" }} >
                                                Please enter valid phone number
                                            </FormHelperText>) : ('')}
                                        </Grid>
                                    </Grid>

                                </Grid>

                                <Grid lg={6} md={6} xs={12} sm={12} className={classes.paddingLeftRight} >
                                    <Grid row >
                                        <Label item title="Contact Person" size={12} />
                                        <Grid lg={12} md={12} sm={12}>
                                            <InputBaseField
                                                name="contactPerson"
                                                type="text"
                                                placeholder="Contact Person"
                                                MaxLength="50"
                                                value={state.contactPerson}
                                                onChange={handleChange}
                                            />
                                            {/*{errorMessages.errorContactPerson && !state.contactPerson ? (<FormHelperText style={{ color: "red" }} >*/}
                                            {/*    Please enter contact person*/}
                                            {/*</FormHelperText>) : ('')}*/}
                                        </Grid>
                                    </Grid>

                                </Grid>

                                {/*<Grid item sm={6} md={6} lg={6} xl={6} className={classes.paddingLeftRight}>*/}
                                {/*    <Grid row>*/}
                                {/*        <Label*/}
                                {/*            title="Select Region"*/}
                                {/*            size={12}*/}
                                {/*            mandatory={true}*/}
                                {/*        />*/}

                                {/*        <SelectField*/}
                                {/*            options={regions}*/}
                                {/*            onChange={handleChange}*/}
                                {/*            value={state.region}*/}
                                {/*            name="region"*/}
                                {/*            placeholder={"Select Region"}*/}
                                {/*            defaultValue={defaultTemplate}*/}
                                {/*            className={classes.selectBaseInput}*/}
                                {/*        ></SelectField>*/}
                                {/*        {errorMessages.errorRegion && !state.region ? (*/}
                                {/*            <FormHelperText style={{ color: "red" }}>*/}
                                {/*                Please select region*/}
                                {/*            </FormHelperText>*/}
                                {/*        ) : (*/}
                                {/*            ""*/}
                                {/*        )}*/}
                                {/*    </Grid>*/}
                                {/*</Grid>*/}
                                <Grid lg={6} md={6} xs={12} sm={12} className={classes.paddingLeftRight} >
                                    <Grid row >
                                        <Label item title="Region/City Name" size={12} mandatory={true} />
                                        <Grid lg={12} md={12}  xs={12} sm={12}>
                                            <InputBaseField
                                                name="region"
                                                type="text"
                                                placeholder="Region/City Name"
                                                MaxLength="50"
                                                value={state.region}
                                                onChange={handleChange}
                                            />
                                            {errorMessages.errorRegion && !state.region ? (<FormHelperText style={{ color: "red" }} >
                                                Please enter region name
                                            </FormHelperText>) : ('')}
                                        </Grid>
                                    </Grid>

                                </Grid>
                                
                            </Grid>
                        </div>

                        <div className={classes.footer}>
                            <div className={classes.footerRight}>
                                <Button className={classes.backBtn} onClick={handleClose}>Cancel</Button>
                                <Button className={classes.changeBtn}
                                    onClick={addAgency}
                                >Save</Button>
                            </div>
                        </div>

                    </div>
                </div>
            </Dialog >
        </>
    )
}

export default withSnackbar(AddNewAgency); 